export const SET_FROM_DATE = 'SET_FROM_DATE'
export const SET_TO_DATE = 'SET_TO_DATE'
export const SET_COLLAPSED = 'SET_COLLAPSED'
export const SET_MY_SHIFTS = 'SET_MY_SHIFTS'
export const SET_OTHER_SHIFTS = 'SET_OTHER_SHIFTS'
export const SET_SHIFT_KEYS = 'SET_SHIFT_KEYS'
